@import "@/scss/use-bootstrap-mixins.scss";

// Banner (collapsed state)
.banner {
    width: 100%;
    padding: 12px 16px;
    border-radius: 12px;
    cursor: pointer;
    background-color: $primary5Pct;
    border: 1px solid $primary;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: background-color 0.15s ease;

    &:hover {
        background-color: $primaryLightest;
    }

    .bannerLeft {
        display: flex;
        flex-direction: column;
        gap: 2px;

        .bannerTitle {
            font-size: 14px;
            font-weight: 700;
            color: $primaryOnBackground;
        }

        .bannerRate {
            font-size: 16px;
            font-weight: 600;
            color: #222;
        }
    }

    .bannerRight {
        display: flex;
        align-items: center;
        gap: 6px;

        .changeDealText {
            font-size: 12px;
            color: $primaryOnBackground;
            font-weight: 500;
        }

        .chevron {
            width: 16px;
            height: 16px;
            color: $primaryOnBackground;
            transition: transform 0.2s ease;
        }
    }
}

.bannerEmpty {
    .bannerTitle {
        animation: pulse 2s ease-in-out infinite;
    }
}

@keyframes pulse {
    0%,
    100% {
        opacity: 1;
    }
    50% {
        opacity: 0.5;
    }
}

// Backdrop overlay
.backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 100;
}

// Bottom sheet (mobile)
.bottomSheet {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 16px 16px 0 0;
    padding: 24px;
    max-height: 80vh;
    overflow-y: auto;
    z-index: 101;

    .dragHandle {
        width: 40px;
        height: 4px;
        border-radius: 2px;
        background: #ccc;
        margin: 0 auto 16px;
    }
}

// Side panel (desktop)
.sidePanel {
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    width: 380px;
    background: #fff;
    box-shadow: -4px 0 20px rgba(0, 0, 0, 0.1);
    z-index: 101;
    padding: 32px;
    overflow-y: auto;

    .closeButton {
        position: absolute;
        top: 16px;
        right: 16px;
        background: none;
        border: none;
        cursor: pointer;
        padding: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        transition: background-color 0.15s ease;

        &:hover {
            background-color: #f0f0f0;
        }

        svg {
            width: 20px;
            height: 20px;
            color: #555;
        }
    }
}

// Shared drawer content
.drawerTitle {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 16px;
    color: #222;
}

.dealCardList {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.dealCard {
    padding: 16px;
    border-radius: 12px;
    border: 2px solid #e0e0e0;
    cursor: pointer;
    transition:
        border-color 0.15s ease,
        background-color 0.15s ease;
    position: relative;

    &:hover {
        border-color: #bbb;
    }

    &.dealCardActive {
        border-color: $primary;
        background-color: $primary5Pct;
    }

    .dealCardHeader {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;

        .dealCardInfo {
            flex: 1;

            .dealCardTitle {
                font-size: 14px;
                font-weight: 700;
                color: #222;
                margin-bottom: 4px;
            }

            .dealCardCustomText {
                font-size: 12px;
                color: #666;
                margin-bottom: 4px;

                span {
                    display: block;
                }
            }
        }

        .dealCardRate {
            font-size: 18px;
            font-weight: 700;
            color: #222;
            white-space: nowrap;
        }
    }

    .dealCardDescriptions {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
        margin-top: 8px;

        .descriptionTag {
            background-color: #f5f5f5;
            border-radius: 4px;
            padding: 3px 8px;
            font-size: 11px;
            font-weight: 500;
            color: #444;
        }
    }

    .checkmark {
        position: absolute;
        top: 12px;
        right: 12px;
        width: 20px;
        height: 20px;
        color: $primaryOnBackground;
    }
}

// Confirm drawer
.confirmContent {
    .previewCard {
        background-color: #f8f8f8;
        border-radius: 12px;
        padding: 20px;
        margin-bottom: 20px;

        .descriptorName {
            font-size: 16px;
            font-weight: 700;
            color: #222;
            margin-bottom: 8px;
        }

        .unitTypeRate {
            font-size: 20px;
            font-weight: 700;
            color: #222;
            margin-bottom: 12px;
        }

        .dealChip {
            display: inline-block;
            padding: 4px 10px;
            border-radius: 20px;
            font-size: 12px;
            font-weight: 600;

            &.dealCarriesOver {
                background-color: #e6f7e6;
                color: #1b7a1b;
            }

            &.dealNotAvailable {
                background-color: #fff3e0;
                color: #c66900;
            }
        }
    }

    .divider {
        width: 100%;
        height: 1px;
        background-color: #e0e0e0;
        margin: 20px 0;
    }

    .confirmButtons {
        display: flex;
        flex-direction: column;
        gap: 10px;

        .cancelButton {
            width: 100%;
            padding: 12px;
            border-radius: 10px;
            border: 1px solid #ccc;
            background: #fff;
            color: #222;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
            transition:
                background-color 0.15s ease,
                border-color 0.15s ease;

            &:hover {
                background-color: #f5f5f5;
                border-color: #aaa;
            }
        }

        .confirmButton {
            width: 100%;
            padding: 12px;
            border-radius: 10px;
            border: none;
            background-color: $primary;
            color: $textColorOnPrimary;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
            transition: opacity 0.15s ease;

            &:hover {
                opacity: 0.9;
            }
        }
    }
}
